// @flow
import React from "react";
import type { FlagContentProps } from "../types";

const UnitedKingdom = ({ circular }: FlagContentProps) =>
  circular ? (
    <React.Fragment>
      <g clipPath="url(#clip0_3_7)">
        <path d="M26 0H-6V19.9784H26V0Z" fill="#F8F8F9" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26 8.32433V11.6757H11.57V19.9784H8.43002V11.6757H-6V8.32433H8.43002V0H11.57V8.32433H26Z"
          fill="#DE3131"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-3.04475 0H7.62194V6.59459L-3.04475 0ZM12.3781 0H23.0447L12.3781 6.59459V0ZM26 2.05405L17.3189 7.41622H26V2.05405ZM17.3189 12.5838H26V17.9459L17.3189 12.5838ZM23.0447 19.9784L12.3781 13.3838V19.9784H23.0447ZM-6 12.5838H2.68109L-6 17.9459V12.5838ZM7.62194 13.4054L-3.04475 20H7.62194V13.4054ZM2.68109 7.41622L-6 2.05405V7.41622H2.68109Z"
          fill="#2959A3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.83549 7.41627L-6 1.34059V0.0865364L5.84414 7.41627H3.83549Z"
          fill="#DE3131"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.62194 12.7352L-4.12988 19.9784H-6V19.9135L5.86722 12.5838H7.62194V12.7352Z"
          fill="#DE3131"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26 0.151351L14.2482 7.41622H12.3781V7.30811L24.2453 0H26V0.151351Z"
          fill="#DE3131"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26 19.8271L14.2482 12.5838H16.2568L26 18.5946V19.8271Z"
          fill="#DE3131"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_7">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <path d="M32 0H0V19.9784H32V0Z" fill="#F8F8F9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 8.32433V11.6757H17.57V19.9784H14.43V11.6757H0V8.32433H14.43V0H17.57V8.32433H32Z"
        fill="#DE3131"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.95525 0H13.6219V6.59459L2.95525 0ZM18.3781 0H29.0447L18.3781 6.59459V0ZM32 2.05405L23.3189 7.41622H32V2.05405ZM23.3189 12.5838H32V17.9459L23.3189 12.5838ZM29.0447 19.9784L18.3781 13.3838V19.9784H29.0447ZM0 12.5838H8.68109L0 17.9459V12.5838ZM13.6219 13.4054L2.95525 20H13.6219V13.4054ZM8.68109 7.41622L0 2.05405V7.41622H8.68109Z"
        fill="#2959A3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.83549 7.41627L0 1.34059V0.0865383L11.8441 7.41627H9.83549Z"
        fill="#DE3131"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6219 12.7352L1.87012 19.9784H0V19.9135L11.8672 12.5838H13.6219V12.7352Z"
        fill="#DE3131"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 0.151351L20.2482 7.41622H18.3781V7.30811L30.2453 0H32V0.151351Z"
        fill="#DE3131"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 19.8271L20.2482 12.5838H22.2568L32 18.5946V19.8271Z"
        fill="#DE3131"
      />
    </React.Fragment>
  );

// $FlowFixMe
export default React.memo(UnitedKingdom);
